import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { AvailableFilters, JobType } from "@utils/enums";
import JobTypeIcon from "@components/Icon/JobTypeIcon";
import { connect } from "react-redux";
import { getFilters } from "@store/selectors/pdf";
const jobTypeMapping = [JobType.ONE_BY_ONE, JobType.ALL_TO_ONE];
const JobTypeFilter = (props) => {
    const selectFilter = (filter) => {
        props.onChange({
            filterName: AvailableFilters.TYPE_NAME,
            filterValue: filter
        });
    };
    return (React.createElement(DropdownButton, { title: "Job Type", id: "jobType", variant: "secondary" }, jobTypeMapping.map(item => (React.createElement(Dropdown.Item, { key: item, onClick: () => selectFilter(item), active: item === props.filters[AvailableFilters.TYPE_NAME] },
        React.createElement(JobTypeIcon, { id: item.toString(), type: item }))))));
};
const mapStateToProps = (state) => ({
    filters: getFilters(state)
});
export default connect(mapStateToProps)(JobTypeFilter);
